import { render } from "./EventCard.vue?vue&type=template&id=2e0273c0"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"
script.render = render

export default script